import { createContext, useContext, useState, useEffect } from 'react';
import api from '../utils/api';

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [token, setToken]   = useState(() => localStorage.getItem('ec_token'));
  const [username, setUser] = useState(() => localStorage.getItem('ec_user'));

  const login = async (username, password) => {
    const { data } = await api.post('/auth/login', { username, password });
    localStorage.setItem('ec_token', data.token);
    localStorage.setItem('ec_user', data.username);
    setToken(data.token);
    setUser(data.username);
  };

  const logout = () => {
    localStorage.removeItem('ec_token');
    localStorage.removeItem('ec_user');
    setToken(null);
    setUser(null);
  };

  return (
    <AuthCtx.Provider value={{ token, username, login, logout }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
